module.exports = {"321204001":"罗塘街道","321204002":"三水街道","321204101":"溱潼镇","321204102":"蒋垛镇","321204103":"顾高镇","321204104":"大伦镇","321204105":"张甸镇","321204107":"梁徐镇","321204109":"桥头镇","321204110":"淤溪镇","321204111":"白米镇","321204112":"娄庄镇","321204113":"沈高镇","321204114":"兴泰镇","321204115":"俞垛镇","321204116":"华港镇","321204401":"溱湖风景区","321204403":"林场","321204404":"种猪场","321204405":"林业站","321204406":"渔业社"}


//////////////////
// WEBPACK FOOTER
// ./src/town/321204.json
// module id = 856
// module chunks = 0